/**
 *
 *
 *
 *
 *
 *
 *
 *
 *
 */
export type Component = "oc-popover-v1";

export type Props = {
  /**
 *
 *
 *
 *
 *
 *
 *
 */
  anchor?: string | HTMLElement | "previous-sibling";

  /**
 *
 *
 *
 *
 *
 *
 */
  closeButton?: boolean;

  /**
 *
 *
 *
 */
  closeOn?:
    | `${OcPopoverTrigger.NONE}`
    | `${OcPopoverTrigger.CLICK}`
    | `${OcPopoverTrigger.MOUSELEAVE}`
    | `${OcPopoverTrigger.BLUR}`;

  /**
 *
 *
 *
 */
  ocAriaLabel?: string;

  /**
 *
 *
 *
 */
  position?: "top" | "bottom";

  /**
 *
 *
 *
 *
 *
 */
  sticky?: boolean;

  /**
 *
 *
 *
 */
  trigger?:
    | `${OcPopoverTrigger.NONE}`
    | `${OcPopoverTrigger.CLICK}`
    | `${OcPopoverTrigger.MOUSEENTER}`
    | `${OcPopoverTrigger.LONGPRESS}`
    | `${OcPopoverTrigger.FOCUS}`;

  /**
 *
 *
 *
 */
  variant?: `${OcPopoverVariant}`;

  /**
 *
 *
 *
 *
 */
  visible?: boolean;
};

export type Methods = {
  /**
 *
 *
 *
 */
  recalcPosition: () => void;
};

export type Events = {
  /**
 *
 *
 */
  "oc-popover-close": CustomEvent<void>;

  /**
 *
 *
 */
  "oc-popover-open": CustomEvent<void>;
};

export type Slots = {
  /**
 *
 *
 *
 *
 */
  default: string;
};

export type CssVariables = {
  /**
 *
 */
  "--arrow-height"?: string;

  /**
 *
 */
  "--background-color"?: string;

  /**
 *
 */
  "--border-radius"?: string;

  /**
 *
 */
  "--max-width"?: string;

  /**
 *
 */
  "--min-width"?: string;

  /**
 *
 */
  "--padding"?: string;
};

export enum OcPopoverTrigger {
  NONE = "none",
  CLICK = "click",
  LONGPRESS = "longpress",
  MOUSEENTER = "mouseenter",
  MOUSELEAVE = "mouseleave",
  FOCUS = "focus",
  BLUR = "blur",
}

export enum OcPopoverVariant {
  FLYOUT = "flyout",
  TOGGLETIP = "toggletip",
  TOOLTIP = "tooltip",
}
